import module from 'module';

import {
  buildCurrentRows,
  buildRecalculatedRows,
  hasCompleteRecalculation,
  toCommandInput
} from './stocked-items-recalculate.mapper';

const templateUrl = require('./stocked-items-recalculate-summary.template.html');
import './stocked-items-recalculate-summary.style.less';

const CALCULATE_URL = '/products/pawns/calculate-stocked-items-selling-price';
const COMMAND = 'RecalculateStockedItemsSellingPrice';

class StockedItemsRecalculateSummary {
  constructor(http, command) {
    this.http = http;
    this.command = command;
    this.itemList = [];
    this.recalculated = false;
    this.calculating = false;
  }

  $onInit() {
    // The preview is read-only and returns the stored values alongside the
    // recomputed ones. The stored per-component metal rate is not on the
    // stocked-items list row (its components carry a rate id but no rate), so the
    // "current" columns are filled from here; the recomputed values are dropped
    // until the operator presses Recalculate, which is what keeps the two "new"
    // columns blank on entry.
    return this.load(buildCurrentRows, false);
  }

  recalculate() {
    // Rebuilding the whole list overwrites the previous computation in place, so
    // pressing Recalculate again cannot duplicate rows.
    return this.load(buildRecalculatedRows, true);
  }

  /**
   * One preview request at a time. Two in flight together can settle in either
   * order, and the older one would then overwrite the newer rows; dropping the
   * second request also stops Apply from offering the previous result while a
   * fresh one is still being fetched, since `recalculated` is cleared up front.
   */
  async load(buildRows, recalculated) {
    if (this.calculating) {
      return;
    }

    this.calculating = true;
    this.recalculated = false;
    try {
      this.itemList = buildRows(await this.calculate());
      this.recalculated = recalculated;
    } finally {
      this.calculating = false;
    }
  }

  calculate() {
    return this.http.post(CALCULATE_URL,
      {itemIds: this.items.map(item => item.id)},
      {nxLoaderText: 'Calculating new selling prices'})
      .toPromise();
  }

  canApply() {
    return this.recalculated && hasCompleteRecalculation(this.itemList);
  }

  apply() {
    return this.command.execute(COMMAND, toCommandInput(this.itemList))
      .success(() => this.cancel());
  }

  cancel() {
    this.mode = null;
  }
}

module.component('stockedItemsRecalculateSummary', {
  templateUrl,
  bindings: {
    mode: '=',
    items: '<'
  },
  controller: StockedItemsRecalculateSummary
});
